module.exports = __webpack_public_path__ + "static/media/202B-1302B.6ae1240d.png";